import Axios from "axios"
import Qs from "qs"
import {
    vueInstance,
    storeInstance
} from "../main"


let BASE_URL = "http://local.vrmaker.vip:8989"
// let BASE_URL = "http://192.168.33.174:8989"
/**
 * 发送普通请求
 * @type {AxiosInstance}
 */
const axios = Axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    },
    transformRequest: function (data) {
        return Qs.stringify(data)
    }
})
const jsonAxios = Axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json"
    }
})
/**
 * 发送文件上传请求
 * @type {AxiosInstance}
 */
const upload = Axios.create({
    baseURL: BASE_URL,
    method: "POST",
    // 不设置请求头， 客户端会自动设置
})

/**
 * 用来创建普通请求方法
 * @param type
 * @param api
 * @param useJson
 * @returns {function(*=): Promise<AxiosResponse<T>>}
 */
export function axiosApi(type, api, useJson, cancelToken) {
    api = BASE_URL + api
    let axiosObj = axios

    if (useJson) {
        axiosObj = jsonAxios
    }



    return function (data) {
        switch (type) {
            case 'get':
                return axiosObj.get(api, {
                    params: data,
                    cancelToken
                });
            case 'post':
                return axiosObj.post(api, data, {
                    cancelToken
                });
            case 'put':
                return axiosObj.put(api, data, {
                    cancelToken
                });
            case 'delete':
                return axiosObj.delete(api, {
                    params: data,
                    cancelToken,
                    paramsSerializer: params => {
                        return Qs.stringify(params, { indices: false })
                    }
                });
        }
    }
}

/**
 * 用来创建文件上传请求方法
 * @param api
 * @returns {function(*=): *}
 */
export function uploadApi(api, usePut) {
    api = BASE_URL + api
    return function (data) {
        return usePut ? upload.put(api, data) : upload.post(api, data);
    }
}

function setToken(config) {
    let token = storeInstance.state.token.token ? storeInstance.state.token.token : sessionStorage.getItem('token')
    // console.log(token,"token")
    config.headers['Authorization'] = 'Bearer ' + (token ? token : '')
    return config;
}

let timer

[jsonAxios, axios, upload].forEach(obj => {
    obj.interceptors.response.use(function (response) {
        return response
    }, function (error) {
        clearTimeout(timer)
        if (error.response && error.response.status === 401) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                vueInstance.$message.error("登录已失效！请重新登录!")
                vueInstance.$router.push("/login")
                clearInterval(vueInstance.fresh)
            }, 800)

        }
        return error;
    });

    obj.interceptors.request.use(setToken, e => {
        console.log(e)
    })
});


// WEBPACK FOOTER //
// ./src/api/api.js